<template>
    <div>
        <div class="overlay" v-if="show" @click="close"></div>
        <div class="modal modal-alt-units" v-if="show">
            <span class="close-modal-btn" @click="close">
                <fa-icon class="close-modal-icon" icon="times" />
            </span>
            <div class="modal-alt-units-content">
                <div class="alt-units-list">
                    <div class="alt-unit-label" @click="selectAltUnitsModalUnit(UNIT_TYPE_FOOTMAN)">
                        <span class="alt-unit-img-wrapper"
                            :class="{
                                'selected': selectedAltUnitsModalUnit === UNIT_TYPE_FOOTMAN,
                                [UNIT_TYPE_FOOTMAN.toLowerCase().replaceAll('_', '-')]: true,
                            }"
                        >
                            <img
                                class="alt-unit-img"
                                :src="getAssetUrl(`@/assets/units/${UNIT_TYPE_FOOTMAN.toLowerCase()}.png`)"
                                :alt="UNIT_TYPE_FOOTMAN"
                            />
                        </span>
                    </div>
                    <div class="alt-unit-label" @click="selectAltUnitsModalUnit(UNIT_TYPE_LANCER)">
                        <span class="alt-unit-img-wrapper"
                            :class="{
                                'selected': selectedAltUnitsModalUnit === UNIT_TYPE_LANCER,
                                [UNIT_TYPE_LANCER.toLowerCase().replaceAll('_', '-')]: true,
                            }"
                        >
                            <img
                                class="alt-unit-img"
                                :src="getAssetUrl(`@/assets/units/${UNIT_TYPE_LANCER.toLowerCase()}.png`)"
                                :alt="UNIT_TYPE_LANCER"
                            />
                        </span>
                    </div>
                    <div class="alt-unit-label" @click="selectAltUnitsModalUnit(UNIT_TYPE_MARSHAL)">
                        <span class="alt-unit-img-wrapper"
                            :class="{
                                'selected': selectedAltUnitsModalUnit === UNIT_TYPE_MARSHAL,
                                [UNIT_TYPE_MARSHAL.toLowerCase().replaceAll('_', '-')]: true,
                            }"
                        >
                            <img
                                class="alt-unit-img"
                                :src="getAssetUrl(`@/assets/units/${UNIT_TYPE_MARSHAL.toLowerCase()}.png`)"
                                :alt="UNIT_TYPE_MARSHAL"
                            />
                        </span>
                    </div>
                </div>
                <div class="selected-alt-unit" v-if="selectedAltUnitsModalUnit === UNIT_TYPE_ROYAL_GUARD">
                    <div class="unit-card-wrapper">
                            <div class="unit-card-title">
                                Classic (v1)
                            </div>
                            <unit-card
                                :unit-type="UNIT_TYPE_ROYAL_GUARD"
                                :image-name="'royal_guard.png'"
                                :quantity="5"
                            />
                        </div>
                        <div class="unit-card-wrapper">
                            <div class="unit-card-title">
                                Nobility Expansion (v2)
                            </div>
                            <unit-card
                                :unit-type="UNIT_TYPE_ROYAL_GUARD_NOBILITY"
                                :image-name="'royal_guard.png'"
                                :quantity="5"
                            />
                        </div>
                </div>
                <div class="selected-alt-unit" v-if="selectedAltUnitsModalUnit === UNIT_TYPE_FOOTMAN">
                    <div class="unit-card-wrapper">
                        <div class="unit-card-title">
                            Footman (v1)
                        </div>
                        <unit-card
                            :unit-type="UNIT_TYPE_FOOTMAN"
                            :image-name="'footman.png'"
                            :quantity="5"
                        />
                    </div>
                    <div class="unit-card-wrapper">
                        <div class="unit-card-title">
                            Vanguard (v2)
                        </div>
                        <unit-card
                            :unit-type="UNIT_TYPE_VANGUARD"
                            :image-name="'vanguard.png'"
                            :quantity="5"
                        />
                    </div>
                </div>
                <div class="selected-alt-unit" v-if="selectedAltUnitsModalUnit === UNIT_TYPE_LANCER">
                    <div class="unit-card-wrapper">
                        <div class="unit-card-title">
                            Lancer (v1)
                        </div>
                        <unit-card
                            :unit-type="UNIT_TYPE_LANCER"
                            :image-name="'lancer.png'"
                            :quantity="4"
                        />
                    </div>
                    <div class="unit-card-wrapper">
                        <div class="unit-card-title">
                            Heavy Cavalry (v2)
                        </div>
                        <unit-card
                            :unit-type="UNIT_TYPE_HEAVY_CAVALRY"
                            :image-name="'heavy_cavalry.png'"
                            :quantity="4"
                        />
                    </div>
                </div>
                <div class="selected-alt-unit" v-if="selectedAltUnitsModalUnit === UNIT_TYPE_MARSHAL">
                    <div class="unit-card-wrapper">
                        <div class="unit-card-title">
                            Marshal (v1)
                        </div>
                        <unit-card
                            :unit-type="UNIT_TYPE_MARSHAL"
                            :image-name="'marshal.png'"
                            :quantity="5"
                        />
                    </div>
                    <div class="unit-card-wrapper">
                        <div class="unit-card-title">
                            Warlord (v2)
                        </div>
                        <unit-card
                            :unit-type="UNIT_TYPE_WARLORD"
                            :image-name="'warlord.png'"
                            :quantity="5"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getAssetUrl } from '../../helpers/assets';
import {
    UNIT_TYPE_MARSHAL,
    UNIT_TYPE_LANCER,
    UNIT_TYPE_FOOTMAN,
    UNIT_TYPE_ROYAL_GUARD,
    UNIT_TYPE_ROYAL_GUARD_NOBILITY,
    UNIT_TYPE_HEAVY_CAVALRY,
    UNIT_TYPE_VANGUARD,
    UNIT_TYPE_WARLORD,
} from '../Unit/Unit-types';

export default {
    props: ['show', 'close', 'showRoyalGuard'],
    name: 'AltUnitsModal',
    created() {
        this.selectAltUnitsModalUnit(UNIT_TYPE_FOOTMAN);
    },
    data() {
        return {
            selectedAltUnitsModalUnit: UNIT_TYPE_ROYAL_GUARD,
            ['UNIT_TYPE_ROYAL_GUARD']: UNIT_TYPE_ROYAL_GUARD,
            ['UNIT_TYPE_ROYAL_GUARD_NOBILITY']: UNIT_TYPE_ROYAL_GUARD_NOBILITY,
            ['UNIT_TYPE_HEAVY_CAVALRY']: UNIT_TYPE_HEAVY_CAVALRY,
            ['UNIT_TYPE_VANGUARD']: UNIT_TYPE_VANGUARD,
            ['UNIT_TYPE_WARLORD']: UNIT_TYPE_WARLORD,
            ['UNIT_TYPE_MARSHAL']: UNIT_TYPE_MARSHAL,
            ['UNIT_TYPE_LANCER']: UNIT_TYPE_LANCER,
            ['UNIT_TYPE_FOOTMAN']: UNIT_TYPE_FOOTMAN,
        };
    },
    methods: {
        getAssetUrl,
        selectAltUnitsModalUnit(unitType) {
            this.selectedAltUnitsModalUnit = unitType;
        },
    },
};
</script>
<style scoped lang="scss">
@use "@/styles/styles.scss" as *;

.modal-alt-units {

    .close-modal-btn {
        cursor: pointer;
        position: absolute;
        right: 20px;
        top: 15px;
    }

    .modal-alt-units-content {

        .alt-units-list {
            display: flex;
            justify-content: space-evenly;
            margin: 5px 0 15px 0;

            .alt-unit-label {
                cursor: pointer;
                display: flex;
                font-size: 0.75rem;
                white-space: nowrap;

                .alt-unit-img-wrapper {
                    padding: 3px;
                    border: 2px solid transparent;
                    border-radius: 50%;
                    cursor: pointer;

                    &.selected {
                        &.footman {
                            border-color: $footman;
                        }

                        &.lancer {
                            border-color: $lancer;
                        }

                        &.marshal {
                            border-color: $marshal;
                        }

                        &.royal-guard {
                            border-color: $royal-guard;
                        }

                        &.trebuchet {
                            border-color: $trebuchet;
                        }
                    }

                    .alt-unit-img {
                        display: block;
                        height: auto;
                        max-height: 30px;
                        max-width: 30px;
                        width: auto;
                    }
                }

                > * {
                    align-self: center;
                }
            }
        }

        .unit-card {
            margin: 0 10px;
        }

        .unit-card-title {
            margin-bottom: 5px;
            text-align: center;
        }
    }

    .selected-alt-unit {
        display: flex;
    }
}
</style>
